<div class="status-dropdown-custom d-flex align-items-center">
    <ng-container *ngIf="['/push-to-petpooja'].includes(router.url)">
        <ng-select [searchable]="true"
            [clearable]="false"
            labelForId="company-name"
            [markFirst]="false"
            [items]="companyList"
            [(ngModel)]="selectedCompanyName"
            (change)="onChange('restaurantSyncCode')"
            (search)="onCompanySearch($event)"
            [typeToSearchText]="'Search company name (at least 3 characters)'"
            bindLabel="name"
            bindValue="restaurantSyncCode"
            appearance="outline"
            class="pmd-select pmd-select-outline status-dropdown-outer w-100 ps-3 bg-white"
            placeholder="Search company name (at least 3 characters)"
            name="companyNameFilter"
            ng-click="active!= ng-select-opened">
        </ng-select>
    </ng-container>
    <ng-container
        *ngIf="['/push-to-petpooja/manage-poss-tags', '/push-to-retail-pos/manage-invoice-tags'].includes(router.url)">
        <ng-select [searchable]="true"
            [clearable]="false"
            labelForId="company-name"
            [markFirst]="false"
            [items]="companyList"
            [(ngModel)]="selectedCompanyName"
            (change)="onChange('id')"
            (search)="onCompanySearch($event)"
            [typeToSearchText]="'Search company name (at least 3 characters)'"
            bindLabel="name"
            bindValue="id"
            appearance="outline"
            class="pmd-select pmd-select-outline status-dropdown-outer w-100 ps-3 bg-white"
            placeholder="Search company name (at least 3 characters)"
            name="companyNameFilter"
            ng-click="active!= ng-select-opened">
        </ng-select>
    </ng-container>

    <ng-container *ngIf="['/push-to-retail-pos'].includes(router.url)">
        <ng-select [searchable]="true"
            [clearable]="false"
            labelForId="company-name"
            [markFirst]="false"
            [items]="companyList"
            [(ngModel)]="selectedCompanyName"
            (change)="onChange('retailPosSyncCode')"
            (search)="onCompanySearch($event)"
            [typeToSearchText]="'Search company name (at least 3 characters)'"
            bindLabel="name"
            bindValue="retailPosSyncCode"
            appearance="outline"
            class="pmd-select pmd-select-outline status-dropdown-outer w-100 ps-3 bg-white"
            placeholder="Search company name (at least 3 characters)"
            name="companyNameFilter"
            ng-click="active!= ng-select-opened">
        </ng-select>
    </ng-container>

</div>
